import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Sprout, LogOut } from "lucide-react";
import PricingTiers from "../shared/PricingTiers";

export default function Paywall() {
  const { user, logout } = useAuth();
  const expired = ["canceled", "unpaid", "past_due", "incomplete_expired"].includes(user?.plan_status);

  return (
    <div className="min-h-screen bg-forest-900 text-white flex flex-col items-center py-14 px-6">
      <div className="absolute top-5 right-5">
        <button data-testid="paywall-logout" onClick={logout} className="flex items-center gap-2 text-sm text-white/60 hover:text-white">
          <LogOut className="h-4 w-4" /> Sign out
        </button>
      </div>

      <div className="flex items-center gap-3 mb-3">
        <div className="h-10 w-10 rounded-md bg-ai flex items-center justify-center"><Sprout className="h-6 w-6" strokeWidth={2.4} /></div>
        <span className="font-heading font-extrabold text-2xl">Assort<span className="text-ai">IQ</span></span>
      </div>

      <h1 data-testid="paywall-card" className="font-heading text-3xl md:text-4xl font-extrabold text-center">
        {expired ? "Your subscription has ended" : `Choose the plan you'll grow into`}
      </h1>
      <p className="mt-2 mb-10 text-white/60 text-sm text-center max-w-xl">
        {expired ? "Resubscribe to keep optimizing your assortment."
          : `Hi ${user?.name || "there"}, every plan starts with a 7-day free trial. Add a card to begin — you won't be charged until day 7. Cancel anytime.`}
      </p>

      <div className="w-full [--tw-text-opacity:1]">
        <PricingTiers dark currentTier={null} highlight="scale" />
      </div>
    </div>
  );
}
